import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=caa8c224&scoped=true&"
import script from "./InfoList.vue?vue&type=script&lang=js&"
export * from "./InfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa8c224",
  null
  
)

export default component.exports